// src/app/modules/Auth/pages/AuthPage.jsx
import React, { useState, useEffect } from "react";
import { Link, Routes, Route, Navigate } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import Login from "./Login";
import Registration from "./Registration";
import Activation from "./Activation";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import OrganizationSetup from "./OrganizationSetup";
import SSOCallback from "./SSOCallback";
import AcceptInvite from "./AcceptInvite";
import "./auth-shell.scss";

export function AuthPage() {
  const [year, setYear] = useState(2023);

  useEffect(() => {
    const d = new Date();
    const n = d.getFullYear();
    setYear(n);
  }, []);

  return (
    <div className="auth-shell">
      <div className="auth-shell__inner">
        <Link to="/" className="auth-shell__logo">
          <img alt="Sety" src={toAbsoluteUrl("/media/logos/Sety_Logo.svg")} />
        </Link>

        <Routes>
          <Route path="login" element={<Login />} />
          <Route path="registration" element={<Registration />} />
          <Route path="activation" element={<Activation />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="organization-setup" element={<OrganizationSetup />} />
          <Route path="sso/callback" element={<SSOCallback />} />
          <Route path="accept-invite" element={<AcceptInvite />} />

          <Route path="/" element={<Navigate to="login" replace />} />
          <Route path="*" element={<Navigate to="login" replace />} />
        </Routes>

        <div className="auth-shell__footer">
          <div className="auth-shell__copyright">&copy; {year} Sety. All rights reserved.</div>
          <div className="auth-shell__links">
            <a href="https://sety.io/terms" className="auth-shell__link">Terms &amp; Conditions</a>
            <span className="auth-shell__divider">&bull;</span>
            <a href="https://sety.io/privacy" className="auth-shell__link">Privacy Policy</a>
          </div>
        </div>
      </div>
    </div>
  );
}